import { useState, useEffect } from "react"
import { EscolaridadeKeys, escolaridadeKeyToLabel, IEscolaridade } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteEscolaridade = () => {
    // Redux State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedEscolaridade, setSelectedEscolaridade] = useState<IEscolaridade[]>([])

    // Hooks
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        const escolaridadesSelecionadas = editRecorteExtracaoForm.fields.Filtros?.escolaridade || [];

        if (escolaridadesSelecionadas.length > 0) {
            setSelectedEscolaridade(escolaridadesSelecionadas);
        } else {
            setSelectedEscolaridade([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.escolaridade]);

    const filteredEscolaridade = EscolaridadeKeys.filter((escolaridade: IEscolaridade) =>
        !selectedEscolaridade.includes(escolaridade)
    );

    const handleEscolaridadeSelectionChange = (value: IEscolaridade[]) => {
        setSelectedEscolaridade(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'escolaridade',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'escolaridade',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredEscolaridade}
                    value={selectedEscolaridade}
                    getOptionLabel={(option) => escolaridadeKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleEscolaridadeSelectionChange(value);
                    }}
                    noOptionsText='Nenhuma escolaridade encontrada'
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de escolaridade"
                        />
                    )}
                />
            </Grid>
        </>
    )
}